import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ReadDetail from '@/components/screens/read-detail/ReadDetail';
import { API_URL, READ_ONLINE_SECRET_KEY } from '@/helpers/variables';
import useRedirectFromReadPage from '@/hooks/useRedirectFromReadPage';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IRead } from '@/interfaces/read.interface';
import { IQuotes } from '@/interfaces/quotes.interface';

interface IReadPage {
  book: IBookShortDetail;
  read: IRead;
  reviews: IReviews;
  quotes: IQuotes;
}

const ReadPage: NextPage<IReadPage> = ({ book, read, reviews, quotes }) => {
  //Check book type
  if (book.book.type === 'pdf' || !book.read_online) {
    useRedirectFromReadPage();
  }

  return <ReadDetail book={book} read={read} reviews={reviews} quotes={quotes} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { bookAlias, alias } = context.query;

  const aliasFragments = String(bookAlias)?.split('-');
  const bookId = aliasFragments[aliasFragments.length - 1];

  const bookRes = await fetch(`${API_URL}satellite/books/kuchaknig/${bookAlias}?author_id_or_alias=${alias}`);
  const book = await bookRes.json();

  // Check fetch error
  if (!bookRes.ok) {
    console.table(`Error ${bookRes.status}. Api: ${bookRes.url}`);
    return {
      notFound: true,
    };
  }
  // Check Fetched Data Error
  // if (!book.id || book.book.external_uid === undefined || book.book.external_id === undefined || book.author.alias !== alias) {
  //   return {
  //     notFound: true,
  //   };
  // }

  const readRes = await fetch(
    book.book.allow_full_free > 0
      ? `${API_URL}read-online?external_uid=${book.book.external_uid}&alias=${book.book.alias}&secret=${READ_ONLINE_SECRET_KEY}`
      : `${API_URL}read-online?external_id=${book.book.external_id}&secret=${READ_ONLINE_SECRET_KEY}`,
  ).catch((e) => {
    console.warn(e);
    return null;
  });

  // Check Fetched Data Error
  if (readRes?.status === 500) {
    return {
      notFound: true,
    };
  }

  const read = await readRes?.json();

  const [reviewsRes, quotesRes] = await Promise.all([fetch(`${API_URL}satellite/reviews/?book_alias=${bookAlias}&page=1&page_size=5`), fetch(`${API_URL}satellite/quotes/?book_id=${bookId}&page=1&page_size=50`)]);
  const [reviews, quotes] = await Promise.all([reviewsRes.json(), quotesRes.json()]);

  return { props: { book, read, reviews, quotes } };
};

export default ReadPage;
